import React from "react";
import moment from "moment";
import { connect } from "react-redux";
import { callService, existeFecha, goTo } from "../tools";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { reject } from "underscore";
import { database } from "../app-database";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { movil } from '../app-movil';
import Modal from '../generalcomponets/modal-mobile'

import './gnp-registro-new-movile.css'

const selector = formValueSelector("datos-poliza");

var isContrat = true;
var polizaGrupo = false;
var certificadoCeros = "";

const mapState = (state) => {
	let dia = "", mes = "", anio = "";
	if (state.registro.inicioVigenciaPolizaDate != "") {
		let date = new Date(state.registro.inicioVigenciaPolizaDate);
		dia = (date.getDate() < 10) ? "0" + date.getDate() : date.getDate();
		mes = (date.getMonth() + 1 < 10) ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
		anio = date.getFullYear();
	}
	let diaNacimiento = "", mesNacimiento = "", anioNacimiento = "";
	if (state.registro.fechaDeNacimientoDate != "") {

		let date = new Date(state.registro.fechaDeNacimientoDate);
		diaNacimiento = (date.getDate() < 10) ? "0" + date.getDate() : date.getDate();
		mesNacimiento = (date.getMonth() + 1 < 10) ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
		anioNacimiento = date.getFullYear();
	}
	return {
		dataForm: selector(state, "poliza", "motor", "placas", "inicioVigenciaPolizaDate", "certificado", "dia", "mes", "anio", "polizaBanamex", "rfcbnmx", "fechaDeNacimientoDate", "diaNacimiento", "mesNacimiento", "anioNacimiento"),
		initialValues: {
			ramo: state.registro.ramo,
			poliza: state.registro.poliza,
			inicioVigenciaPoliza: state.registro.inicioVigenciaPoliza,
			inicioVigenciaPolizaDate: state.registro.inicioVigenciaPolizaDate,
			certificado: state.registro.certificado,
			motor: state.registro.motor,
			placas: state.registro.placas,
			dia: dia,
			mes: mes,
			anio: anio,
			rfcbnmx: state.registro.rfcbnmx,
			diaNacimiento: diaNacimiento,
			mesNacimiento: mesNacimiento,
			anioNacimiento: anioNacimiento,
			fechaDeNacimiento: state.registro.fechaDeNacimiento,
			fechaDeNacimientoDate: state.registro.fechaDeNacimientoDate,
			polizaBanamex: state.registro.polizaBanamex,
			codFiliacion: state.registro.codFiliacion,
			idParticipante: state.registro.idParticipante,
			apaterno: state.registro.apaterno,
			amaterno: state.registro.amaterno,
			nombres: state.registro.nombres,
			avisoAceptado: state.registro.avisoAceptado
		},
		grupo: state.registro.configuracion.grupo,
		motor: state.registro.configuracion.motor,
		certificado: state.registro.configuracion.certificado,
		poliza_valida: state.registro.configuracion.poliza_valida,
		poliza_padre: state.registro.configuracion.poliza_padre,
		referencia: state.registro.configuracion.referencia,
		conectaMovil: state.global.conectaMovil,
		dispositivo: state.global.dispositivo,
		showAviso: state.registro.showAviso
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({ "type": "LOADER", "show": show });
		},
		alerta: (sMensaje) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "ERROR", "mensaje": sMensaje });
		},
		alertaCode: (sCode) => {
			dispatch({ "type": "MODAL_ALERT_CODE_SHOW", "codigo": sCode });
		},
		guardarConfiguracion: (oConfiguracion) => {
			dispatch({ "type": "REGISTRO_POLIZA_CONFIGURACION", "configuracion": oConfiguracion });
		},
		polizaValida: (valida) => {
			dispatch({ "type": "REGISTRO_POLIZA_CONFIGURACION_VALIDA", "poliza_valida": valida });
		},
		polizaValidaFchVigInicial: (valida, fecha) => {
			dispatch({ "type": "REGISTRO_POLIZA_CONFIGURACION_VALIDA_FECHA", "poliza_valida": valida, "fchVigInicial": fecha });
		},
		aviso: (sMensaje) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "Aviso de privacidad.", "mensaje": sMensaje });
		},
		avisoPrivacidad: (showAviso) => {
			dispatch({ "type": "AVISO_PRIVACIDAD", "showAviso": showAviso });
		},
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		}
	};
};

const onSubmitFail = (errors, dispatch, submitError, props) => {
	if (errors.poliza != "Campo requerido." || errors.dia != "Campo requerido.") {
		dispatch({ "type": "EVENT_REGISTRO_SIG-INCORRECTOS", "dispositivo": props.dispositivo });
	} else {
		dispatch({ "type": "EVENT_REGISTRO_SIG-VACIOS", "dispositivo": props.dispositivo });
	}
};

const validate = values => {
	const errors = {};

	if (!values.poliza) {
		errors.poliza = "Campo requerido.";
	} else if (!/^[a-zA-Z0-9_-]*$/i.test(values.poliza)) {
		errors.poliza = "Este campo sólo acepta números y letras.";
	}

	if (!values.certificado) {
		errors.certificado = "Campo requerido.";
	} else if (values.certificado && values.certificado.length < 8 && polizaGrupo === false) {
		errors.certificado = "Este campo no puede ser menor de 8 caracteres.";
	} else if (values.certificado && !/^[a-zA-Z0-9_-]*$/i.test(values.certificado)) {
		errors.certificado = "Este campo sólo acepta números y letras.";
	}

	if (!values.dia || !values.mes || !values.anio) {
		errors.dia = "Campo requerido.";
	} else if (existeFecha(values.dia, values.mes, values.anio) == false) {
		errors.dia = "La fecha inicio de vigencia es inválida. Verifícala e intenta de nuevo.";
	}

	if (!values.motor && !values.placas) {
		errors.motor = "Campo requerido.";
		errors.placas = "Campo requerido.";
	}
	if (!values.rfcbnmx) {
		errors.rfcbnmx = "Campo RFC requerido.";
	} else if (!/^[a-zA-Z0-9_]*$/i.test(values.rfcbnmx)) {
		errors.rfcbnmx = "Este campo sólo acepta números y letras.";
	}

	if (!values.rfcbnmx) {
		errors.rfcbnmx = "Campo requerido.";
	} else if (/^[a-zA-Z]{3,4}(\d{6})((\D|\d){2,3})?$/.test(values.rfcbnmx) == false) {
		errors.rfcbnmx = "Formato de RFC inválido.";
	} else if (values.rfcbnmx && values.diaNacimiento && values.mesNacimiento && values.anioNacimiento) {
		if (values.rfcbnmx.substr("4", "6") != values.anioNacimiento.toString().substr("2", "2") + values.mesNacimiento + values.diaNacimiento) {
			errors.rfcbnmx = "El RFC no concuerda con la fecha de nacimiento.";
		}
	}

	return errors;
};

const espacios = tipo => (value, campos) => {
	let texto = (value != undefined) ? value.replace(/\s/g, "") : "";
	campos[tipo] = texto.toUpperCase();
};

const limpiar = (value) => {
	return (value != undefined) ? value.replace(/\s/g, "").toUpperCase() : "";
};

const campoSettings = {
	fontFamily:'Roboto',
	fontStyle: 'normal',
	fontWeight: 'normal',
	mixBlendMode: 'normal',
}

const floatingLabelStyleSettings={
		...campoSettings,
		lineHeight: '24px',
		letterSpacing: '0.5px',
		color: '#0C2040',
}

const floatingLabelFocusStyleSettings={
	...campoSettings,
	lineHeight: '16px',
	letterSpacing: '0.4px',
	color: '#FF6B0B',
}

const campo = ({ ...custom, input, label, max, type, focus, blur, change, meta: { touched, error } }) => {
	return (
		<MuiThemeProvider>
			<TextField
				floatingLabelText={label}
				fullWidth={true}
				underlineStyle={{borderColor: '#AAC3EE'}}
				underlineFocusStyle={{borderColor: '#FF6B0B'}}
				floatingLabelStyle={floatingLabelStyleSettings}
				floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
				type={type}
				onFocus={focus}
				onBlur={(event) => { input.onBlur(event); blur(event); }}
				onChange={(event) => { console.log(event.target.name);input.onChange(event); change(event); }}
				maxLength={max}
				errorText={touched && error}
			/>
		</MuiThemeProvider>
	);
};

function MyError(message) {
	//this.name = "MyError";
	//this.message = message || "Default Message";
	//this.stack = (new Error()).stack;
	this.message = { "codigoError": "ERROR", "mensaje": "Lo sentimos, verifica el RFC y fecha de nacimiento" };
	//Object.assign(message, { "message": { "codigoError": "ERROR", "mensaje": "AAASDSA" }, "error": message });

}
MyError.prototype = Object.create(Error.prototype);
MyError.prototype.constructor = MyError;

const campoSelect = ({input, label, type, blur, change, name, meta: { touched, error }, children, ...custom}) => {
	return (
			<MuiThemeProvider>
				<SelectField
					{...input}
					name={name}
					floatingLabelText={label}
					underlineStyle={{borderColor: '#AAC3EE'}}
					underlineFocusStyle={{borderColor: '#FF6B0B'}}
					floatingLabelStyle={floatingLabelStyleSettings}
					floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
					onBlur={(event, index, value) => { input.onBlur(event); blur(event, index, value, name); }}
					onChange={(event, index, value) => { input.onChange(value); change(event, index, value, name); }}
					children={children}
					fullWidth={true}
					errorText={touched && error}
					{...custom}
					/>
			</MuiThemeProvider>
	);
};

class PolizaForm extends React.Component {

	state = {
		autos: "", vida: "", gm: "", danios: "",
		images: [
			require("../img/icon_autos_off.svg"),
			require("../img/icon_vida_off.svg"),
			require("../img/icon_gastos_off.svg"),
			require("../img/icon_danos_off.svg"),
			require("../img/icon_autos.svg"),
			require("../img/icon_vida.svg"),
			require("../img/icon_gastos.svg"),
			require("../img/icon_danos.svg")
		],
		ramo: "",
		poliza: "",
		polizaReal: "",
		disabledMotor: false,
		disabledPlacas: false,
		rfcbnmx: "",
		polizaBanamex: false,
		codFiliacion: "",
		idParticipante: "",
		apaterno: "",
		amaterno: "",
		nombres: "",
		fechaDeNacimiento: "",
		fechaDeNacimientoDate: "",
		mensajeAviso: "",
		avisoAceptado: false,
		btnAvisoActivado: true,
		tipo: "contratante",
		esContratante: true,
		mensajeTratamientoDatos: "",
		isModalOpened: false,
		modalMesage:{type: null, message: null}
	}

	componentWillMount = () => {
		this.setRamo(this.props.initialValues.ramo);
		var $this = this;
		database.ref("/documentacion/avisoSimplificado").once("value").then(function (data) {
			$this.setState({ "mensajeAviso": data.val() });
		});
		database.ref("/documentacion/avisoTratamientoDatos").once("value").then(function (data) {
			$this.setState({ "mensajeTratamientoDatos": data.val() });
		});
	}

	resetRamo = () => {
		this.setState({
			autos: this.state.images[0],
			vida: this.state.images[1],
			gm: this.state.images[2],
			danios: this.state.images[3]
		});
	}

	resetConfiguracion = () => {
		this.props.guardarConfiguracion({ grupo: false, motor: false, certificado: false, poliza_valida: false, poliza_padre: false, fchVigInicial: false, referencia: false, sistema: false });

		this.props.change("certificado", "");
		this.props.change("placas", "");
		this.props.change("motor", "");

		this.props.untouch("placas");
		this.props.untouch("motor");
		this.props.untouch("certificado");

		this.props.change("checkPolizaBanamex", false);
		this.props.change("fechaDeNacimiento", "");
		this.props.untouch("checkPolizaBanamex");
		this.props.untouch("fechaDeNacimiento");
	}

	setPolizaReal = (sPoliza) => {
		this.setState({ polizaReal: sPoliza });
		this.props.change("polizaReal", sPoliza);
	}

	setRamo = (sRamo) => {
		this.resetRamo();
		this.setState({ ramo: sRamo });
		this.props.change("ramo", sRamo);

		switch (sRamo) {
			case "A": this.setState({ "autos": this.state.images[4] }); break;
			case "V": this.setState({ "vida": this.state.images[5] }); break;
			case "G": this.setState({ "gm": this.state.images[6] }); break;
			case "D": this.setState({ "danios": this.state.images[7] }); break;
		}
		console.log("set check poliza banamex: " + this.state.polizaBanamex);
	}

	setDetallesPoliza(clienteUnico, idParticipante, apaterno, amaterno, nombres) {
		console.log("setDetallesPoliza");
		this.setState({ codFiliacion: clienteUnico });
		this.props.change("codFiliacion", clienteUnico);

		this.setState({ idParticipante: idParticipante });
		this.props.change("idParticipante", idParticipante);

		this.setState({ apaterno: apaterno });
		this.props.change("apaterno", apaterno);

		this.setState({ amaterno: amaterno });
		this.props.change("amaterno", amaterno);

		this.setState({ nombres: nombres });
		this.props.change("nombres", nombres);
	}

	setRFC = (sRFC) => {
		this.setState({ rfcbnmx: sRFC });
		this.props.change("rfcbnmx", sRFC);
	}

	checkPolizaBanamex = (spolizaBanamex) => {

		if (spolizaBanamex.startsWith('CBX') || spolizaBanamex.startsWith('cbx')) {
			//console.log("Es banamex");
			this.setState({ polizaBanamex: true });
			this.props.change("polizaBanamex", true);

		} else {
			//console.log("No es banamex");

			this.setState({ polizaBanamex: false });
			this.props.change("polizaBanamex", false);
		}
		console.log("set check poliza banamex: " + this.state.polizaBanamex);
	}

	getFechaVigencia = () => {
		let dia = this.diaInicioPoliza.value;
		let mes = this.mesInicioPoliza.value
		let anio = this.anioInicioPoliza.value

		if (dia != "" && mes != "" && anio != "") {
			let date = new Date(anio, mes - 1, dia);
			this.props.change("inicioVigenciaPoliza", moment(anio + "-" + mes + "-" + dia, "YYYY-MM-DD").format("DD - MMMM - YYYY"));
			this.props.change("inicioVigenciaPolizaDate", date.getTime());

			return dia + "/" + mes + "/" + anio;
		} else {
			return false;
		}
	}

	getFechaNacimiento = () => {
		let dia = this.diaNacimiento.value;
		let mes = this.mesNacimiento.value
		let anio = this.anioNacimiento.value

		if (dia != "" && mes != "" && anio != "") {
			let date = new Date(anio, mes - 1, dia);
			this.props.change("fechaDeNacimiento", moment(anio + "-" + mes + "-" + dia, "YYYY-MM-DD").format("DD - MMMM - YYYY"));
			this.props.change("fechaDeNacimientoDate", date.getTime());

			return dia + "/" + mes + "/" + anio;
		} else {
			return false;
		}
	}

	getFechatoActualiza = () => {
		let dia = this.diaNacimiento.value;
		let mes = this.mesNacimiento.value
		let anio = this.anioNacimiento.value

		if (dia != "" && mes != "" && anio != "") {
			return anio + mes + dia;
		} else {
			return "00000000";
		}
	}

	getFechaToDate = (sFecha) => {
		sFecha = sFecha.split("/").reverse();
		sFecha = new Date(sFecha[0], sFecha[1] - 1, sFecha[2]);
		return sFecha.getTime();
	}

	fechaformat = (sFecha) => {
		sFecha = sFecha.split("/").reverse();
		return sFecha[0] + sFecha[1] + sFecha[2];
	}

	handleChange = (event) => {
		let tipo = event.target.name;
		let oForm = this.props.dataForm;

		if (tipo == "poliza" || tipo == "dia" || tipo == "mes" || tipo == "anio") {
			this.resetConfiguracion();
		}

		if (tipo == "certificado" || tipo == "motor" || tipo == "placas") {
			this.props.polizaValida(false);
		}
	}

	handleChangeSelect = (event, index, value, tipo) => {
		let oForm = this.props.dataForm;

		if (tipo == "poliza" || tipo == "dia" || tipo == "mes" || tipo == "anio") {
			this.resetConfiguracion();
		}

		if (tipo == "certificado" || tipo == "motor" || tipo == "placas") {
			this.props.polizaValida(false);
		}
	}

	handleBlur = (event) => {
		let tipo = event.target.name;
		let oForm = this.props.dataForm;
		if (tipo == "poliza" && oForm.dia != "" && oForm.mes != "" && oForm.anio != "" && event.target.value != "") {
			this.resetConfiguracion();
		}
	}

	handleBlurSelect = (event, index, value, tipo) => {
		let oForm = this.props.dataForm;
		if (tipo == "poliza" && oForm.dia != "" && oForm.mes != "" && oForm.anio != "" && event.target.value != "") {
			this.resetConfiguracion();
		}
	}

	handleFocus = (event) => {
		let tipo = event.target.name;

		if (tipo == "placas" || tipo == "motor") {
			this.props.polizaValida(false);
		}
	}

	validarPoliza = (oForm) => {
		console.log("validarPoliza");
		let $this = this;
		$this.props.loader(true);

		let llamaServicio = new callService({
			service: "utilerias.identificaPoliza",
			secure: true,
			data: { poliza: limpiar(oForm.poliza), fecha: $this.getFechaVigencia() }
		}).execute().then((oResult) => {
			console.log("Respuesta", oResult);
            localStorage.setItem("sistemaOrigen", oResult.sistema);
			// GOOGLE TAG MANAGER //
			$this.props.tagManager({ "type": "EVENT_REGISTRO_SIG-CORRECTOS", "dispositivo": $this.props.dispositivo });

			$this.props.loader(false);
			$this.setRamo(oResult.ramo);
			$this.setPolizaReal(oResult.numPoliza);
			$this.checkPolizaBanamex(oForm.poliza);
			$this.props.guardarConfiguracion(oResult);
			this.setState({ sistema: oResult.sistema });

			// ************* Se verifica si la poliza es del grupo de gastos medicos ********
			if(oResult.grupo === true && oResult.sistema === "INFO" && oResult.ramo === "G"){
				polizaGrupo = true;
			}else{
				polizaGrupo = false;
			}
			// ******************************************************************************

			if (oResult.poliza_valida == true) {
				$this.envioAutomatico();
			}
		}).catch((error) => {
			console.log("Error", error);
			// GOOGLE TAG MANAGER //
			$this.props.tagManager({ "type": "EVENT_REGISTRO_SIG-INCORRECTOS", "dispositivo": $this.props.dispositivo });

			$this.props.loader(false);
			$this.resetConfiguracion();
			if (error.message.codigoError != "ERROR") {
				$this.props.alertaCode(error.message.codigoError);
			} else {
				// $this.props.alerta(error.message.mensaje);
				this.openModalParent('error', "Error",error.message.mensaje);
			}
		});
	}

	validarAuto = (oForm) => {
		console.log("validarAuto");
		let $this = this;
		$this.props.polizaValida(false);
		$this.props.loader(true);

		let llamaServicio = new callService({
			service: "utilerias.identificaPolizaAuto",
			secure: true,
			data: {
				poliza: limpiar(oForm.poliza), motor: limpiar(oForm.motor), placas: limpiar(oForm.placas), fecha: $this.getFechaVigencia()
			}
		}).execute().then((oResult) => {
			console.log("Respuesta", oResult);
			// GOOGLE TAG MANAGER //
			$this.props.tagManager({ "type": "EVENT_REGISTRO_SIG-AUTOS-CORRECTOS", "dispositivo": $this.props.dispositivo });
			//$this.actualizaTodo();
			$this.props.loader(false);
			$this.props.polizaValida(true);
			$this.envioAutomatico();
		}).catch((error) => {
			console.log("Error", error);
			// GOOGLE TAG MANAGER //
			$this.props.tagManager({ "type": "EVENT_REGISTRO_SIG-AUTOS-INCORRECTOS", "dispositivo": $this.props.dispositivo });

			$this.props.loader(false);
			if (error.message.codigoError != "ERROR") {
				$this.props.alertaCode(error.message.codigoError);
			} else {
				$this.props.alerta(error.message.mensaje);
			}
		});
	}

	detallePoliza = (oForm) => {
		let $this = this;
		//console.log("*detallePoliza: " + $this.state.polizaReal);

		let llamaServicio = new callService({
			service: "utilerias.detallePoliza",
			secure: true,
			data: { poliza: $this.state.polizaReal }
		});
		return llamaServicio.execute();
	}

	actualizaPersona = (params) => {
		//console.log("*Actualiza Poliza");
		let clienteUnico = "";
		let idParticipante = "";
		let apaterno = "";
		let amaterno = "";
		let nombres = "";
		let codFiliacion = "";
		let RFC = this.state.rfcbnmx;
		let fechaNacimiento = ""; // this.getFechatoActualiza();
		let usuarioAudit = "operadorcrm";


		if (params.conductor.rfc && params.conductor.rfc.trim() == RFC) {
			console.log("Es el conductor.");
			codFiliacion = params.conductor.clienteUnico;
			idParticipante = params.conductor.idParticipante;
			apaterno = params.conductor.apellidoPaterno;
			amaterno = params.conductor.apellidoMaterno;
			nombres = params.conductor.nombres;
			fechaNacimiento = this.fechaformat(params.conductor.fchNacimiento); //.replace(/\//g, "");

		} else if (params.contratante.rfc && params.contratante.rfc.trim() == RFC) {
			console.log("Es contratante");
			codFiliacion = params.contratante.clienteUnico;
			idParticipante = params.contratante.idParticipante;
			apaterno = params.contratante.apellidoPaterno;
			amaterno = params.contratante.apellidoMaterno;
			nombres = params.contratante.nombres;
			fechaNacimiento = this.fechaformat(params.contratante.fchNacimiento);  //.replace(/\//g, "");
		}

		if (codFiliacion && idParticipante && apaterno && nombres) {
			this.setDetallesPoliza(codFiliacion, idParticipante, apaterno, amaterno, nombres);
			let llamaServicio = new callService({
				service: "utilerias.actualizaPersona",
				secure: true,
				data: { codigoFiliacion: codFiliacion, idParticipante: idParticipante, RFC: RFC, fechaNacimiento: fechaNacimiento, apellidoPaterno: apaterno, apellidoMaterno: amaterno, nombre: nombres, usuarioAudit: usuarioAudit }
			});
			return llamaServicio.execute();
		} else {
			//reject(new Error("Whoops!"));
			throw new MyError("ERROR");
		}
	}

	actualizaPolizaBanamex = (oForm) => {
		this.props.loader(true);
		///console.log("Llamando...");
		this.detallePoliza(oForm)
			.then(this.actualizaPersona)
			.then(result => {
				console.log("persona actualizada OK");
				this.validarAuto(oForm);
			}
			).catch((error) => {
				console.log("Error", error);
				// GOOGLE TAG MANAGER //
				this.props.tagManager({ "type": "EVENT_REGISTRO_SIG-AUTOS-INCORRECTOS", "dispositivo": this.props.dispositivo });

				this.props.loader(false);
				if (error.message.codigoError != "ERROR") {
					this.props.alertaCode(error.message.codigoError);
				} else {
					this.props.alerta(error.message.mensaje);
				}
			});
	}

	// actualizaPolizaBanamex = (oForm) => {

	// 	console.log("ACTUALIZA");
	// 	let $this = this;
	// 	var clienteUnico = "", idParticipante = "", apaterno = "", amaterno = "", nombres = "", RFC = "";
	// 	console.log("detallePoliza: " + $this.state.polizaReal);
	// 	$this.props.loader(true);

	// 	let llamaServicio = new callService({
	// 		service: "utilerias.detallePoliza",
	// 		secure: true,
	// 		data: { poliza: $this.state.polizaReal }
	// 	}).execute().then((oResult) => {
	// 		console.log("Respuesta", oResult);
	// 		clienteUnico = oResult.contratante.clienteUnico;
	// 		idParticipante = oResult.contratante.idParticipante;
	// 		apaterno = oResult.contratante.apellidoPaterno;
	// 		amaterno = oResult.contratante.apellidoMaterno;
	// 		nombres = oResult.contratante.nombres;

	// 		RFC = $this.state.rfcbnmx;


	// 		console.log("Consultando detalle poliza: ");
	// 		console.log("clienteUnico: " + clienteUnico);
	// 		console.log("idParticipante: " + idParticipante);
	// 		console.log("apaterno: " + apaterno);
	// 		console.log("amaterno: " + amaterno);
	// 		console.log("nombres: " + nombres);

	// 		$this.setDetallesPoliza(clienteUnico, idParticipante, apaterno, amaterno, nombres);
	// 		let fecha = $this.getFechatoActualiza();

	// 		return {
	// 			fecha,
	// 			$this,
	// 			oForm
	// 		};


	// 	}).then(function (params) {
	// 		let $this = params.$this;
	// 		let oForm = params.oForm;
	// 		console.log("Actualiza Poliza");
	// 		let codFiliacion = clienteUnico;
	// 		console.log("*codFiliacion: " + codFiliacion);


	// 		let fechaNacimiento = params.fecha;

	// 		let usuarioAudit = "operadorcrm";


	// 		let llamaServicio = new callService({
	// 			service: "utilerias.actualizaPersona",
	// 			secure: true,
	// 			data: { codigoFiliacion: codFiliacion, idParticipante: idParticipante, RFC: RFC, fechaNacimiento: fechaNacimiento, apellidoPaterno: apaterno, nombre: nombres, usuarioAudit: usuarioAudit }
	// 		}).execute().then((oResult) => {
	// 			console.log("Respuesta", oResult);
	// 			//$this.props.tagManager({ "type": "EVENT_REGISTRO_SIG-AUTOS-CORRECTOS", "dispositivo": $this.props.dispositivo });
	// 			if (oResult.actualizaPersona) {
	// 				console.log("SE ACTUALIZO CORRECTAMENTE");
	// 			}
	// 			//$this.envioAutomatico();
	// 			//$this.props.loader(false);

	// 		}).catch((error) => {
	// 			console.log("Error", error);
	// 			if (error.message.codigoError != "ERROR") {
	// 				$this.props.alertaCode(error.message.codigoError);
	// 			} else {
	// 				$this.props.alerta(error.message.mensaje);
	// 			}
	// 		});

	// 		return {
	// 			oForm,
	// 			$this
	// 		};

	// 	}).then(function (params) {
	// 		let oForm = params.oForm;
	// 		let $this = params.$this;

	// 		console.log("validarAuto");

	// 		$this.props.polizaValida(false);
	// 		//$this.props.loader(true);

	// 		let llamaServicio = new callService({
	// 			service: "utilerias.identificaPolizaAuto",
	// 			secure: true,
	// 			data: {
	// 				poliza: limpiar(oForm.poliza), motor: limpiar(oForm.motor), placas: limpiar(oForm.placas), fecha: $this.getFechaVigencia()
	// 			}
	// 		}).execute().then((oResult) => {
	// 			console.log("Respuesta validarAuto", oResult);
	// 			// GOOGLE TAG MANAGER //
	// 			$this.props.tagManager({ "type": "EVENT_REGISTRO_SIG-AUTOS-CORRECTOS", "dispositivo": $this.props.dispositivo });
	// 			//$this.actualizaTodo();
	// 			$this.props.loader(false);
	// 			$this.props.polizaValida(true);
	// 			$this.envioAutomatico();
	// 		}).catch((error) => {
	// 			console.log("Error", error);
	// 			// GOOGLE TAG MANAGER //
	// 			$this.props.tagManager({ "type": "EVENT_REGISTRO_SIG-AUTOS-INCORRECTOS", "dispositivo": $this.props.dispositivo });

	// 			$this.props.loader(false);
	// 			if (error.message.codigoError != "ERR|OR") {
	// 				$this.props.alertaCode(error.message.codigoError);
	// 			} else {
	// 				$this.props.alerta(error.message.mensaje);
	// 			}
	// 		});

	// 	}).catch((error) => {
	// 		console.log("Error", error);
	// 		$this.props.loader(false);
	// 		if (error.message.codigoError != "ERROR") {
	// 			$this.props.alertaCode(error.message.codigoError);
	// 		} else {
	// 			$this.props.alerta(error.message.mensaje);
	// 		}
	// 	});
	// }

	validarCertificado = (oForm) => {
		console.log("validarCertificado");
		let $this = this;
		$this.props.polizaValida(false);
		$this.props.loader(true);

		// *************************************************
		console.log("certificado sin ceros", oForm.certificado);
		if(polizaGrupo === true){
			certificadoCeros = oForm.certificado.padStart(10,0);
			console.log("certificado con ceros", certificadoCeros);
		}
		else{
			certificadoCeros = oForm.certificado;
			console.log("No se agregan ceros", certificadoCeros);
		}
		// *************************************************

		let llamaServicio = new callService({
			service: "utilerias.identificaCertificado",
			secure: true,
			data: { poliza: limpiar(oForm.poliza), certificado: limpiar(certificadoCeros), sistema: $this.props.certificado }
		}).execute().then((oResult) => {
			console.log("Respuesta", oResult);
			// GOOGLE TAG MANAGER //
			var type = ($this.state.ramo == "V") ? "EVENT_REGISTRO_SIG-VIDA-CORRECTOS" : "EVENT_REGISTRO_SIG-GMM-CORRECTOS";
			$this.props.tagManager({ "type": type, "dispositivo": $this.props.dispositivo });

			$this.props.loader(false);
			$this.props.polizaValida(true);
			$this.envioAutomatico();
		}).catch((error) => {
			console.log("Error", error);
			// GOOGLE TAG MANAGER //
			var type = ($this.state.ramo == "V") ? "EVENT_REGISTRO_SIG-VIDA-INCORRECTOS" : "EVENT_REGISTRO_SIG-GMM-INCORRECTOS";
			$this.props.tagManager({ "type": type, "dispositivo": $this.props.dispositivo });

			$this.props.loader(false);
			if (error.message.codigoError != "ERROR") {
				$this.props.alertaCode(error.message.codigoError);
			} else {
				$this.props.alerta(error.message.mensaje);
			}
		});
	}

	validarCertificadoPadre = (oForm) => {
		console.log("validarCertificadoPadre");
		let $this = this;
		$this.props.polizaValida(false);
		$this.props.loader(true);

		let llamaServicio = new callService({
			service: "utilerias.identificaPolizaHija",
			secure: true,
			data: { poliza: limpiar(oForm.poliza), certificado: limpiar(oForm.certificado), sistema: $this.props.certificado }
		}).execute().then((oResult) => {
			console.log("Respuesta", oResult);
			// GOOGLE TAG MANAGER //
			var type = ($this.state.ramo == "V") ? "EVENT_REGISTRO_SIG-VIDA-CORRECTOS" : "EVENT_REGISTRO_SIG-GMM-CORRECTOS";
			$this.props.tagManager({ "type": type, "dispositivo": $this.props.dispositivo });

			$this.props.loader(false);
			$this.props.polizaValidaFchVigInicial(oResult.numPoliza, $this.getFechaToDate(oResult.fchVigInicial));
			$this.envioAutomatico();
		}).catch((error) => {
			console.log("Error", error);
			// GOOGLE TAG MANAGER //
			var type = ($this.state.ramo == "V") ? "EVENT_REGISTRO_SIG-VIDA-INCORRECTOS" : "EVENT_REGISTRO_SIG-GMM-INCORRECTOS";
			$this.props.tagManager({ "type": type, "dispositivo": $this.props.dispositivo });

			$this.props.loader(false);
			if (error.message.codigoError != "ERROR") {
				$this.props.alertaCode(error.message.codigoError);
			} else {
				$this.props.alerta(error.message.mensaje);
			}
		});
	}

	cancelar = () => {
		this.props.tagManager({ "type": "EVENT_REGISTRO_POLIZA-CANCELAR", "dispositivo": this.props.dispositivo });
		let mensaje = {"return": "home"};
		movil("", mensaje);
		// goTo("login");
	}

	envioAutomatico = () => {
		this.props.handleSubmit(values => this.props.onSubmit({ ...values }))();
	}

	siguiente = () => {
		let oForm = this.props.dataForm;
		//let spolizaBanamex = oForm.poliza;

		if (oForm.poliza.startsWith('CBX') || oForm.poliza.startsWith('cbx')) {
			//console.log("Es banamex");
			if (oForm.poliza.length > 10) {	//Remover 0 despues de CBX4
				oForm.poliza = oForm.poliza.slice(0, 4) + oForm.poliza.slice(5);
				console.log("Poliza corregida:" + oForm.poliza);
			}
		}

		if (this.props.poliza_valida == false && this.props.grupo && this.props.certificado && oForm.certificado != "") {
			if (this.props.poliza_padre) {
				this.validarCertificadoPadre(oForm);
			} else {
				this.validarCertificado(oForm);
			}
		} else if (this.props.poliza_valida == false && this.props.grupo && this.props.motor && (oForm.motor != "" || oForm.placas != "")) {
			//this.detallePoliza();
			oForm.poliza = this.state.polizaReal;
			//this.getFechaNacimiento();
			//this.setRFC(oForm.rfcbnmx);
			if (this.props.referencia) {
				oForm.poliza = this.props.referencia;
			}

			console.log("BNMX: " + this.state.polizaBanamex);

			if (this.state.polizaBanamex) {
				this.getFechaNacimiento();
				this.setRFC(oForm.rfcbnmx);
				this.actualizaPolizaBanamex(oForm);
			} else {
				this.validarAuto(oForm);
			}
			//this.validarAuto(oForm);
		}
		else if (this.props.poliza_valida == false && this.props.grupo && this.props.motor && this.state.polizaBanamex) {
			console.log("Sig Banamex");
			this.getFechaNacimiento();
			this.setRFC(oForm.rfcbnmx);
			this.actualizaPolizaBanamex(oForm);

			//this.validarAutoBan(oForm);
			//this.actualizaPoliza();
		}
		else if (this.props.poliza_valida == false && this.props.grupo == false && oForm.poliza != "" && this.getFechaVigencia()) {

			this.validarPoliza(oForm);
			//this.checkPolizaBanamex(oForm.poliza);
		}

		else {
			console.log("else");
			this.envioAutomatico();
			this.props.handleSubmit(values => this.props.onSubmit({ ...values }))();
		}
	}

	whatIWantToRunOnSubmit = (values) => {
		console.log("whatIWantToRunOnSubmit" + values);
		if (this.props.poliza_valida == true) {
			this.props.onSubmit({ ...values });
		} else {
			return false;
		}
	}

	openModalParent = (type, title, message) => {
		let { isModalOpened } = this.state;

		if(isModalOpened)
		  this.setState({ isModalOpened: false, modalMesage:{ type: null, title: null,  message: null}})
		else{
		  this.setState({ isModalOpened: true, modalMesage:{ type, title, message}});
		}
	}

	closeModalFromChild = () => {
		this.setState({ isModalOpened: false, modalMesage:{ type: null, message: null}})
	  }

	/* Aviso de privacidad */
	aceptarAvisoPrivacidad = () => {
		this.setState({ "avisoAceptado": true });
		this.props.change("avisoAceptado", true);
		this.props.avisoPrivacidad(false);
	}

	cancelarAvisoPrivacidad = () => {}

	checkAviso = () => {
		if (aceptarAvisoWebView.checked) {
			this.setState({ "btnAvisoActivado": false });
		} else {
			this.setState({ "btnAvisoActivado": true });
		}
	}

	checkContratante = () => {
		console.log("radio");
		this.props.change("esContratante", true);
		this.props.change("tipo", "contratante");
		isContrat = true;
		console.log("Es: ", this.state.tipo);
		console.log("bool:", this.state.esContratante);
		console.log("3:", isContrat);
	}

	checkConductor = () => {
		console.log("radio2");
		this.props.change("esContratante", false);
		this.props.change("tipo", "conductor");
		isContrat = false;
		console.log("Es: ", this.state.tipo);
		console.log("bool:", this.state.esContratante);
		console.log("3:", isContrat);
	}
	
	showModal = () => {
		$("#modal-aviso-privaciad").modal({backdrop: "static", keyboard: false});
	}

	showModal2 = () => {
		$("#modal-terminos-condiciones").modal({backdrop: "static", keyboard: false});
	}

	render() {
		var dias = [], meses = [], anios = [], diasNac = [], mesesNac = [], aniosNac = [];
		for (let i = 1; i <= 31; i++) {
			let dia = (i < 10) ? "0" + i : i;
			dias.push(<MenuItem value={dia} key={i} primaryText={dia} />);
			if (i <= 12) {
				meses.push(<MenuItem value={dia} key={i} primaryText={dia} />);
			}
		}
		for (let i = 1; i <= 31; i++) {
			let diaN = (i < 10) ? "0" + i : i;
			diasNac.push(<MenuItem value={diaN} key={i} primaryText={diaN} />);
			if (i <= 12) {
				mesesNac.push(<MenuItem value={diaN} key={i} primaryText={diaN} />);
			}
		}
		for (let i = new Date().getFullYear(); i >= 1980; i--) {
			anios.push(<MenuItem value={i} key={i} primaryText={i} />)
		}
		for (let i = new Date().getFullYear(); i >= 1920; i--) {
			aniosNac.push(<MenuItem value={i} key={i} primaryText={i} />)
		}

		const { handleSubmit, submitting } = this.props;


		return (
			<form onSubmit={handleSubmit(this.whatIWantToRunOnSubmit)} className="remove-all-styles">
				{this.state.avisoAceptado === true &&
					<div className="container">
						<div className="margin-mobile">
							<div className="row">
								<div className="col-md-12 col-sm-12 col-xs-12">
									<Field name="poliza" type="text" component={campo} blur={this.handleBlur.bind(this)} change={this.handleChange.bind(this)} validate={espacios("poliza")} max="15" label="No. póliza o No. referencia" />
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12">
									<label className="gnp-material-label margin-labels">Fecha inicio vigencia de la póliza</label>
								</div>
								<div className="col-md-4 col-sm-4 col-xs-4 select-field-left">
									<Field  ref={elem => this.diaInicioPoliza = elem} label="Día" name="dia" component={campoSelect} change={this.handleChangeSelect.bind(this)} blur={this.handleBlurSelect.bind(this)}>
										{dias}
									</Field>
								</div>
								<div className="col-md-4 col-sm-4 col-xs-4 select-field-center">
									<Field ref={elem => this.mesInicioPoliza = elem} label="Mes" name="mes" component={campoSelect} change={this.handleChangeSelect.bind(this)} blur={this.handleBlurSelect.bind(this)}>
										{meses}
									</Field>
								</div>
								<div className="col-md-4 col-sm-4 col-xs-4 select-field-right">
									<Field ref={elem => this.anioInicioPoliza = elem} label="Año" name="anio" component={campoSelect} change={this.handleChangeSelect.bind(this)} blur={this.handleBlurSelect.bind(this)}>
										{anios}
									</Field>
								</div>
							</div>
						{this.state.polizaBanamex &&
							<div className="row">
								<div className="col-md-12 col-sm-12 col-xs-12">
									<Field name="rfcbnmx" type="text" component={campo} blur={this.handleBlur.bind(this)} change={this.handleChange.bind(this)} validate={espacios("rfcbnmx")} max="15" label="RFC" />
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12">
									<label className="gnp-material-label margin-labels">Fecha de nacimiento</label>
								</div>
								<div className="col-md-4 col-sm-4 col-xs-4 select-field-left">
										<Field ref={elem => this.diaNacimiento = elem} label="día" name="diaNacimiento" component={campoSelect} change={this.handleChangeSelect.bind(this)} blur={this.handleBlurSelect.bind(this)}>
											{diasNac}
										</Field>
								</div>
								<div className="col-md-4 col-sm-4 col-xs-4 select-field-center">
										<Field ref={elem => this.mesNacimiento = elem} label="mes" name="mesNacimiento" component={campoSelect} change={this.handleChangeSelect.bind(this)} blur={this.handleBlurSelect.bind(this)}>
											{mesesNac}
										</Field>
								</div>
								<div className="col-md-4 col-sm-4 col-xs-4 select-field-right">
										<Field ref={elem => this.anioNacimiento = elem} label="año" name="anioNacimiento" component={campoSelect} change={this.handleChangeSelect.bind(this)} blur={this.handleBlur.bind(this)}>
											{aniosNac}
										</Field>
								</div>
								<div className="col-md-6 col-xs-6 margin-radios">
									<label className="material-gnp-radio" onClick={this.checkContratante}>
										<input type="radio" name="group" />
										<span>Soy Contratante</span>
									</label>
								</div>
								<div className="col-md-6 col-xs-6 margin-radios">
									<label className="material-gnp-radio" onClick={this.checkConductor}>
										<input type="radio" name="group" />
										<span>Soy Conductor</span>
									</label>
								</div>
							</div>
						}
						{this.props.grupo && this.props.certificado &&
							<div className="row">
								<div className="col-md-12 col-sm-12 col-xs-12">
									<Field name="certificado" type="text" component={campo} blur={this.handleBlur.bind(this)} change={this.handleChange.bind(this)}
										validate={espacios("certificado")}
										max="10"
										label={(this.state.ramo == "V" && this.props.certificado == "INFO") ? "Código cliente" : "No. de certificado"}
									/>
								</div>
							</div>
						}
						{this.props.grupo && this.props.motor &&
							<div className="row">
								<div className="col-md-12 col-sm-12 col-xs-12">
									<Field name="placas" type="text" component={campo} focus={this.handleFocus.bind(this)} blur={this.handleBlur.bind(this)} change={this.handleChange.bind(this)} validate={espacios("placas")} max="12" label="Placa" />
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12">
									<Field name="motor" type="text" component={campo} focus={this.handleFocus.bind(this)} blur={this.handleBlur.bind(this)} change={this.handleChange.bind(this)} validate={espacios("motor")} max="22" label="Número de serie" />
								</div>
							</div>
						}
						<Field name="polizaReal" component="input" type="hidden" />
						<Field name="ramo" component="input" type="hidden" />
						<Field name="inicioVigenciaPoliza" component="input" type="hidden"/>
						<Field name="inicioVigenciaPolizaDate" component="input" type="hidden" />

							<div className="row" >
									<div className="registro-button-container">
											<div className="col-md-12 col-sm-12 col-xs-12">
													<button type="button" onClick={this.siguiente} className="pure-material-button-contained btn-full-width">Continuar</button>
											</div>
									</div>
							</div>
						</div>
					</div>
				}
				
				{this.state.isModalOpened &&
					<Modal closeModalFromChild={this.closeModalFromChild}>
						<div className="container">
							<div className="row">
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-top">
										{this.state.modalMesage.type === "error" && <img src={require('../img/warning-new-style.svg')} alt="Error image modal" className="gnp-material-comtent-image" />}
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal">
									<label className="gnp-material-title-modal">{this.state.modalMesage.title}</label>
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 margin-modal">
									<p className=" gnp-material-content-modal">{this.state.modalMesage.message}</p>
								</div>
								<div className="col-md-12 col-sm-12 col-xs-12 text-center margin-modal-bottom">
									<button type="button" onClick={this.closeModalFromChild} className="pure-material-button-contained btn-full-width">Aceptar</button>
								</div>
							</div>
						</div>
					</Modal>	
				}

				{this.state.avisoAceptado === false &&
				<div className="container">
					<div className="row">
						<div id="aviso-inicio-registro">
							<div className="col-xs-12 margin-top-title">
								<h3>Aviso de privacidad</h3><br/>
								<div dangerouslySetInnerHTML={{ __html: this.state.mensajeTratamientoDatos }} id="container-aviso-inicio-registro-2"></div>
							</div>
							<div className="col-xs-12 margin-top-title border-check-aviso-bottom">
								<div dangerouslySetInnerHTML={{ __html: this.state.mensajeAviso }} id="container-aviso-inicio-registro-1"></div>
							</div>

							<div className="col-xs-2 text-center margin-check" style={{paddingTop: '10px'}}>
								<label className="pure-material-checkbox">
									<input type="checkbox" id="aceptarAvisoWebView" name="aceptarAvisoWebView" value="avisoWebView" onChange={this.checkAviso}/>
									<span></span>
								</label>
							</div>

							<div className="col-xs-10 margin-check">
								<p id="aviso-privacidad-registro" style={{marginTop: '11px'}}>Autorizo</p>
							</div>

							<div className="col-xs-12 border-check-aviso">
								<div className="margin-aviso-inicio-si">
									<button disabled={this.state.btnAvisoActivado} className="pure-material-button-contained btn-full-width" onClick={ this.aceptarAvisoPrivacidad }>Continuar</button>
								</div>
								<div className="margin-aviso-inicio-no">
									<button className="pure-material-button-outlined-registro btn-full-width"
									style={{marginBottom: '35px'}} onClick={ this.cancelar }>Regresar</button>
								</div>
							</div>
						</div>
					</div>
				</div>	
				}
			</form >


			
		);
	}
}

PolizaForm = reduxForm({ form: "datos-poliza", onSubmitFail })(PolizaForm);
export default connect(mapState, mapDispatch)(PolizaForm);




// WEBPACK FOOTER //
// ./src/gnp-registro/poliza.movil.frm.js